import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { findHallByPostcode } from "@/lib/areas";

/**
 * Postcode lookup — type a 4-digit postcode, jump straight to the nearest
 * service-area landing page.
 */
export default function PostcodeSearch({ inverted = false }) {
  const [pc, setPc] = useState("");
  const [err, setErr] = useState("");
  const navigate = useNavigate();
  const onSubmit = (e) => {
    e.preventDefault();
    setErr("");
    const match = findHallByPostcode(pc);
    if (!match) {
      setErr("That postcode isn't in our usual service area — message the team and we'll let you know.");
      return;
    }
    navigate(`/service-areas/${match.primarySuburbSlug}`);
  };
  return (
    <form onSubmit={onSubmit} className={`mt-6 flex flex-wrap items-center gap-2 ${inverted ? "" : ""}`} data-testid="postcode-search">
      <label className={`text-xs uppercase tracking-wider font-semibold ${inverted ? "text-stone-700" : "text-white/80"}`}>What's your postcode?</label>
      <div className={`flex items-center gap-2 rounded-xl ${inverted ? "bg-white border border-stone-200" : "bg-white/95"} px-3 py-2 shadow-sm`}>
        <MagnifyingGlass size={16} weight="bold" className="text-[#1b4a76]" />
        <input
          value={pc}
          onChange={(e) => setPc(e.target.value.replace(/[^0-9]/g, "").slice(0, 4))}
          placeholder="4564"
          inputMode="numeric"
          className="bg-transparent outline-none text-stone-900 placeholder:text-stone-400 w-28 text-sm font-mono"
          data-testid="postcode-input"
        />
        <button className="bg-[#f38838] hover:bg-[#d97324] text-white font-semibold text-sm rounded-lg px-3 py-1.5" data-testid="postcode-submit">
          Find local class
        </button>
      </div>
      {err && <p className={`w-full text-xs ${inverted ? "text-red-600" : "text-amber-200"}`} data-testid="postcode-err">{err}</p>}
    </form>
  );
}
